import React from "react"

import { Typography } from "@mui/material"

import { Card, Tilt3D, Tilt3DLayer } from "../../../../components"

import "./style.scss"

/** Arrondis à reproduire sur le reflet pour qu'il épouse la forme du contenu */
const CARD_RADIUS = "0.5rem 0.5rem 2rem 2rem"
const TILE_RADIUS = "1rem"

/** Exemples d'utilisation de Tilt3D et Tilt3DLayer */
const Effets3D = () => (
  <ul className="styleguide-effets-3d">
    <li className="styleguide-effets-3d__example">
      <Tilt3D borderRadius={CARD_RADIUS}>
        <Card actions={[{ label: "Action", onClick: () => {} }]}>
          <Typography variant="h5">Carte inclinable</Typography>
          <Typography>Survole-moi</Typography>
        </Card>
      </Tilt3D>
      <Typography variant="body2" component="p">
        {"<Tilt3D> : suivi au survol avec reflet (par défaut)"}
      </Typography>
    </li>

    <li className="styleguide-effets-3d__example">
      <Tilt3D shine float borderRadius={TILE_RADIUS}>
        <div className="styleguide-effets-3d__tile">Shine + float</div>
      </Tilt3D>
      <Typography variant="body2" component="p">
        {"<Tilt3D shine float> : éclat périodique et lévitation"}
      </Typography>
    </li>

    <li className="styleguide-effets-3d__example">
      <Tilt3D maxTilt={14} borderRadius={TILE_RADIUS}>
        <div className="styleguide-effets-3d__tile is-layered">
          <Tilt3DLayer depth="3rem">
            <span className="styleguide-effets-3d__badge">Profondeur</span>
          </Tilt3DLayer>
        </div>
      </Tilt3D>
      <Typography variant="body2" component="p">
        {'<Tilt3DLayer depth="3rem"> : calque décollé (maxTilt 14)'}
      </Typography>
    </li>

    <li className="styleguide-effets-3d__example">
      <Tilt3D tracking="window" glare={false} borderRadius={TILE_RADIUS}>
        <div className="styleguide-effets-3d__tile is-pink">
          Toute la fenêtre
        </div>
      </Tilt3D>
      <Typography variant="body2" component="p">
        {'<Tilt3D tracking="window" glare={false}> : suit la souris partout'}
      </Typography>
    </li>
  </ul>
)

export default Effets3D
